import { Avatar, Card, Col, Row, Image, Button, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { ChangeEvent, useEffect, useState } from "react";
import { IDashboardTableCardProps } from "./DashboardTableCard.model";
import {
  encrypt,
  getStudentPerformanceGrade,
  openInNewTab,
} from "src/utils/helperFunction";
import {
  AdmisionStatusType,
  AdmissionCertificateGrade,
  CertificateStatus,
  CertificateStatusLabel,
  NsdcBatchesStatus,
  placementPortalRegistrationUrl,
} from "src/utils/constants/constant";
import { loginSelector } from "src/state/Login/login.reducer";
import {
  clearRemoveMessage,
  studentSelector,
} from "src/state/student/student.reducer";
import { useAppSelector } from "src/state/app.hooks";
import ModalComponent from "../Modal";
import { studentExamSelector } from "src/state/exam/exam.reducer";
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/state/app.model";
import { getExamResultDetails } from "src/state/exam/exam.action";
import { useParams } from "react-router-dom";
import { IExamResultData } from "src/services/exam/exam.model";
import { StudentVerificationDetails } from "../Certificate";
import moment from "moment";
import {
  createCertificate,
  getStudentAdmissionDetailsById,
} from "src/state/student/student.action";

const DashboardTableCard = (props: IDashboardTableCardProps) => {
  const {
    student_name,
    student_full_name,
    gr_id,
    email,
    status,
    course,
    image_path,
    enrollment_number,
    careerCourse,
    package_id,
  } = props;
  const loginState = useAppSelector(loginSelector);
  const studentState = useAppSelector(studentSelector);
  const studentExamState = useAppSelector(studentExamSelector);
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const [openCountModel, setOpenCountModel] = useState<boolean>(false);
  const [data, setData] = useState<IExamResultData>();
  const [openCertificateModal, setOpenCertificateModal] = useState(false);
  const [certificateApplied, setCertificateApplied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  const isStudentMobileNumber = () => {
    const loginMobileNumber = loginState?.verifyData?.data?.mobile_no;
    const studentData = studentState?.getById?.data[0];
    const fatherMobileNumber = studentData.father_mobile_no;
    const motherMobileNumber = studentData.mother_mobile_no;

    return !(
      loginMobileNumber === fatherMobileNumber ||
      loginMobileNumber === motherMobileNumber
    );
  };
  const studentData = studentState?.getById?.data?.[0];
  const getNsdcData = Array.isArray(studentData?.nsdc_students)
    ? [...studentData.nsdc_students].sort(
        (a, b) =>
          new Date(b.created_date).getTime() -
          new Date(a.created_date).getTime()
      )[0]
    : undefined;

  const latestValidNsdcStudent =
    getNsdcData &&
    getNsdcData.deleted_date === null &&
    getNsdcData.nsdc_batch_id &&
    getNsdcData.nsdc_batches?.status === NsdcBatchesStatus.COMPLETE &&
    studentData?.status === AdmisionStatusType.COMPLETED
      ? getNsdcData
      : undefined;

  const isNsdcCompletedStudent = !!latestValidNsdcStudent;
  const isShowCertificateBtn = studentData.show_certificate_btn;
  const branchData = studentData.branch?.name;
  const branchId = studentData.branch?.id;
  const dateFormat = "YYYY-MM-DD";
  const currentdate = new Date();
  const admissionStart = studentData?.created_date
    ? moment(studentData.created_date).format(dateFormat)
    : moment(currentdate).format(dateFormat);

  let admissionEnd = "-";
  if (Array.isArray(studentData?.admission_status_histories)) {
    const completedHistory = studentData.admission_status_histories
      .filter((history) => history.status === AdmisionStatusType.COMPLETED)
      .sort(
        (a, b) =>
          new Date(b.created_date).getTime() -
          new Date(a.created_date).getTime()
      )[0];
    if (completedHistory?.created_date) {
      admissionEnd = moment(completedHistory.created_date).format(dateFormat);
    }
  }
  const percentage = studentData?.student_performance ?? null;
  const grade = getStudentPerformanceGrade(Number(percentage) || 0);

  let certificateCourseName: string;

  if (studentData?.package?.certificate_package_name) {
    certificateCourseName = studentData.package.certificate_package_name.trim();
  } else {
    certificateCourseName = studentData?.admission_subcourses
      ?.map((res) => res.subcourse.certificate_subcourse_name?.trim())
      ?.filter(Boolean)
      ?.join(", ");
  }
  const handleTermsChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTermsAccepted(e.target.checked);
  };

  const studentCanEligibleForJobApply = () => {
    const studentLogin = isStudentMobileNumber();
    const checkAdmissionStatus = status === AdmisionStatusType.COMPLETED;
    if (studentLogin && checkAdmissionStatus && careerCourse) {
      return true;
    }
    return false;
  };

  const studentCanEligibleForCertificateApply = () => {
    const studentLogin = isStudentMobileNumber();
    const checkAdmissionStatus = status === AdmisionStatusType.COMPLETED;
    if (studentLogin && checkAdmissionStatus) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    const Payload = {
      admission_id: Number(id),
      package_id: Number(package_id),
    };
    if (package_id && id) {
      dispatch(getExamResultDetails(Payload));
    }
  }, [package_id]);

  useEffect(() => {
    if (studentState.createCertificate.message) {
      if (studentState.createCertificate.hasErrors) {
        message.error(studentState.createCertificate.message);
      } else {
        message.success(studentState.createCertificate.message);
      }
      dispatch(clearRemoveMessage());
    }
  }, [studentState.createCertificate.message]);

  useEffect(() => {
    if (studentExamState.getExamResultDetails.data) {
      setData(studentExamState.getExamResultDetails.data);
    }
  }, [studentExamState.getExamResultDetails.data]);

  const handleCertificateSubmit = () => {
    const payload = {
      admission_id: studentData?.id,
      package_id: studentData?.package_id || null,
      subcourse_id:
        studentData?.package_id === null
          ? studentData?.admission_subcourses?.map(
              (subcourse) => subcourse.subcourse_id
            )
          : null,
      first_name: studentData?.first_name,
      middle_name: studentData?.middle_name,
      last_name: studentData?.last_name,
      email: studentData?.email,
      certificate_status: isNsdcCompletedStudent
        ? CertificateStatus.NSDC_PENDING
        : CertificateStatus.PENDING,
      is_nsdc_certificate: isNsdcCompletedStudent ? true : false,
      branch_id: branchId,
      start_date: admissionStart,
      end_date: admissionEnd,
      grade: grade,
      certificate_course_name: certificateCourseName
    };

    setLoading(true);

    dispatch(createCertificate(payload))
      .unwrap()
      .then(() => {
        return dispatch(
          getStudentAdmissionDetailsById(Number(studentData?.id))
        );
      })
      .then(() => {
        setCertificateApplied(true);
        setOpenCertificateModal(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Card className="student-details-card">
        <Row gutter={15} className="gx-align-items-center">
          <Col
            xs={8}
            sm={5}
            md={4}
            lg={4}
            xl={6}
            xxl={4}
            className="gx-text-center"
          >
            <div className="card-profile">
              {image_path ? (
                <Avatar src={<Image src={image_path} />} />
              ) : (
                <Avatar className="avtar-default" icon={<UserOutlined />} />
              )}
            </div>
          </Col>
          <Col xs={14} className="gx-d-sm-none">
            <div className="profile-details">
              <h5 className="usernameMobile">{student_name}</h5>
              <span>GR Id : {gr_id}</span>
            </div>
          </Col>
          <Col
            xs={24}
            sm={18}
            md={20}
            lg={20}
            xl={18}
            xxl={20}
            className="gx-pl-md-0"
          >
            <div className="profile-details mobile-profile">
              <Row gutter={[16, 16]}>
                <Col
                  xs={24}
                  sm={12}
                  md={{ span: 6, order: 1 }}
                  xl={{ span: 8, order: 1 }}
                  xxl={{ span: 8, order: 1 }}
                >
                  <label>Name</label>
                  <h5 className="gx-mb-0">{student_name}</h5>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={{ span: 3, order: 2 }}
                  xl={{ span: 4, order: 2 }}
                >
                  <label>GR ID</label>
                  <h5 className="gx-mb-0">{gr_id}</h5>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={{ span: 4, order: 3 }}
                  xl={{ span: 6, order: 3 }}
                >
                  <label>Status</label>
                  <h5 className="gx-mb-0 gx-text-capitalize">
                    {status?.toLowerCase()}
                  </h5>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={{ span: 6, order: 4 }}
                  xl={{ span: 8, order: 4 }}
                >
                  <label>Enrollment No.</label>
                  <h5>{enrollment_number}</h5>
                </Col>
                {data?.credits && (
                  <Col
                    xs={24}
                    sm={12}
                    md={{ span: 4, order: 6 }}
                    xl={{ span: 4, order: 6 }}
                  >
                    <Button
                      className="btn-submit "
                      key="submit"
                      type="primary"
                      htmlType="submit"
                      onClick={() => setOpenCountModel(true)}
                    >
                      Result
                    </Button>
                  </Col>
                )}
                <Col
                  xs={24}
                  sm={12}
                  md={{ span: 6, order: 5 }}
                  xl={{ span: 4, order: 5 }}
                >
                  <label>Course</label>
                  <h5 className="gx-mb-0">{course}</h5>
                </Col>
                {studentCanEligibleForJobApply() && (
                  <Col
                    xs={24}
                    sm={12}
                    md={{ span: 6, order: 7 }}
                    xl={{ span: 6, order: 7 }}
                  >
                    <Button
                      className="btn-submit "
                      key="submit"
                      type="primary"
                      htmlType="submit"
                      onClick={() =>
                        openInNewTab(
                          `${placementPortalRegistrationUrl}?gr=${encrypt(
                            gr_id?.toString() || ""
                          )}&email=${encrypt(email?.toString() || "")}`
                        )
                      }
                    >
                      Apply for Job
                    </Button>
                  </Col>
                )}
                {studentCanEligibleForCertificateApply() &&
                  isShowCertificateBtn && (
                    <Col
                      xs={24}
                      sm={12}
                      md={{ span: 4, order: 8 }}
                      xl={{ span: 6, order: 8 }}
                    >
                      <Button
                        className="btn-submit"
                        key="submit"
                        type="primary"
                        htmlType="submit"
                        onClick={() => setOpenCertificateModal(true)}
                      >
                        Apply for Certificate
                      </Button>
                    </Col>
                  )}
              </Row>
            </div>
          </Col>
        </Row>
        {openCertificateModal && (
          <ModalComponent
            title="Please Verify Your Details"
            showModal={openCertificateModal}
            onCancel={() => setOpenCertificateModal(false)}
            component={
              <StudentVerificationDetails
                studentState={studentData}
                student_full_name={student_full_name?.toUpperCase() ?? ""}
                course={certificateCourseName || course || ""}
                email={email ?? ""}
                grade={grade}
                start_date={admissionStart}
                end_date={admissionEnd}
                branch_name={branchData}
                termsAccepted={termsAccepted}
                onCheckboxChange={handleTermsChange}
              />
            }
            footer={[
              <Button
                key="cancel"
                onClick={() => setOpenCertificateModal(false)}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={handleCertificateSubmit}
                disabled={!termsAccepted || certificateApplied}
              >
                Submit
              </Button>,
            ]}
          />
        )}

        {openCountModel && (
          <ModalComponent
            className=""
            title="Result"
            showModal={openCountModel}
            onCancel={() => {
              setOpenCountModel(false);
            }}
             component={
              <>
                <div>
                  {data ? (
                    data.credits?.slice(0, 3).map((result, index) => (
                      <tr key={index}>
                        <td>
                          <ol start={index + 1}>
                            <li>{result.package_name}</li>
                          </ol>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <p>No Data</p>
                  )}
                </div>
              </>
            }
            footer={[
              <div>
                <Button key="back" onClick={() => setOpenCountModel(false)}>
                  Cancel
                </Button>
              </div>,
            ]}
          ></ModalComponent>
        )}
        {/* <div className="profile-more-details">
            <Row gutter={15}>
            <Col xs={12} md={6} className="gx-px-2">
              <a href="javascript:;" className="profile-option">
              <ClockCircleFilled />
              <h6>Schedule</h6>
              </a>
            </Col>
            <Col xs={12} md={6} className="gx-px-2">
              <a href="javascript:;" className="profile-option">
              <CarryOutFilled />
              <h6>Attendance</h6>
              </a>
            </Col>
            <Col xs={12} md={6} className="gx-px-2 gx-mt-2 gx-mt-md-0">
              <a href="javascript:;" className="profile-option">
              <ReadFilled />
              <h6>Courses</h6>
              </a>
            </Col>
            <Col xs={12} md={6} className="gx-px-2 gx-mt-2 gx-mt-md-0">
              <a href="javascript:;" className="profile-option">
              <ScheduleFilled />
              <h6>Signing Sheet</h6>
              </a>
            </Col>
            </Row>
            <Row gutter={15} className="gx-mt-2 gx-mt-md-3">
            <Col xs={12} md={6} className="gx-px-2">
              <a href="javascript:;" className="profile-option">
              <CreditCardFilled />
              <h6>Fee Details</h6>
              </a>
            </Col>
            <Col xs={12} md={6} className="gx-px-2">
              <a href="javascript:;" className="profile-option">
              <IdcardFilled />
              <h6>Details</h6>
              </a>
            </Col>
            <Col xs={12} md={6} className="gx-px-2 gx-mt-2 gx-mt-md-0">
              <a href="javascript:;" className="profile-option">
              <TrophyFilled />
              <h6>Certificate</h6>
              </a>
            </Col>
            <Col xs={12} md={6} className="gx-px-2 gx-mt-2 gx-mt-md-0">
              <a href="javascript:;" className="profile-option">
              <MessageFilled />
              <h6>Feedback</h6>
              </a>
            </Col>
            </Row>
            </div>
         */}
      </Card>
    </>
  );
};
export default DashboardTableCard;
